import React from "react";
import SearchSuggestions from "./SearchSuggestions";
import "./css/SearchBar.css";
import SearchIcon from "./images/searchIconDark.svg";
import Loading from "./images/loading.svg";
import { ROOT_API_PATH } from "./actions/constant";

class SeachBar extends React.Component {
  constructor() {
    super();
    this.state = {
      result: [],
      loading: false,
      showList: false
    };
  }

  searchString = event => {
    var value = event.target.value;
    if (value !== "" && value.length >= 3) {
      var trodlySearch = ROOT_API_PATH + "ajax/suggestion.php?category=ActivitiesActivities&term=" + value;

      var xhr = new XMLHttpRequest();
      xhr.open("GET", trodlySearch);
      xhr.send();

      var that = this;
      xhr.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var res = JSON.parse(this.responseText);
          that.setState({
            result: res,
            loading: false,
            showList: true
          });
        }
      };
      this.setState({
        loading: true
      });
    } else {
      this.setState({
        showList: false
      });
    }
  };
  render() {
    return (
      <div className="searchbar-contianer row">
        <div className="col-xl-offset-2 col-xl-8 col-md-12 col-lg-8 col-sm-12">
          <div className="closeSearchBar" onClick={this.props.closeSearchBar}>
            <span />
          </div>
          <div className="search-icons-input">
            <div className="searchIcon" style={{ height: "2rem", width: "2rem" }}>
              <img src={this.state.loading ? Loading : SearchIcon} alt="" />
            </div>
            <div className="search-input">
              <input
                type="text"
                autoFocus={true}
                style={{ fontSize: "1.5rem" }}
                onKeyUp={this.searchString}
                placeholder="Search"
                aria-label="Search activities in Trodly.com"
              />
            </div>
            <SearchSuggestions result={this.state.result} showList={this.state.showList} />
          </div>
        </div>
      </div>
    );
  }
}

export default SeachBar;



// WEBPACK FOOTER //
// ./src/WholePageSearchBar.jsx